<template>
  <div class="choice-cards">
    <button
      v-for="option in options"
      :key="String(option.value)"
      type="button"
      class="choice-card"
      :class="{ 'is-selected': option.value === value, 'is-disabled': disabled }"
      :disabled="disabled"
      @click="$emit('input', option.value)">
      <span class="choice-card-head">
        <span class="choice-card-icon">
          <feather-icon :icon="option.icon || 'CircleIcon'" svgClasses="w-5 h-5"/>
        </span>
        <span class="choice-card-title">{{ option.title }}</span>
        <feather-icon
          v-if="option.value === value"
          icon="CheckCircleIcon"
          class="choice-card-check"
          svgClasses="w-5 h-5"/>
      </span>
      <small class="choice-card-description">{{ option.description }}</small>
      <small v-if="option.example" class="choice-card-example">{{ option.example }}</small>
    </button>
  </div>
</template>

<script>
/**
 * Escolha única em cartões grandes, no lugar de radios secos.
 *
 * Existe porque as escolhas estruturais (tipo de aula, tipo de plano) eram
 * três siglas num radio — quem não é técnico escolhia errado e só descobria
 * na vitrine. Cada cartão explica a opção e dá um exemplo concreto.
 *
 * options: [{ value, title, description, example?, icon? }]
 */
export default {
  name: 'ChoiceCards',
  props: {
    options: { type: Array, required: true },
    value: { type: [String, Number], default: null },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.choice-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.75rem;
}

.choice-card {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  text-align: left;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 0.6rem;
  background: transparent;
  padding: 0.85rem 1rem;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  color: inherit;

  &:hover:not(.is-disabled) {
    border-color: rgba(115, 103, 240, 0.6);
  }

  &.is-selected {
    border-color: #7367f0;
    box-shadow: 0 0 0 1px #7367f0 inset;
    background: rgba(115, 103, 240, 0.06);
  }

  &.is-disabled {
    cursor: default;
    opacity: 0.6;
  }
}

.choice-card-head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.choice-card-icon {
  display: inline-flex;
  color: #7367f0;
  flex: 0 0 auto;
}

.choice-card-title {
  font-weight: 600;
  font-size: 0.98rem;
}

.choice-card-check {
  margin-left: auto;
  color: #28c76f;
  flex: 0 0 auto;
}

.choice-card-description {
  opacity: 0.8;
  line-height: 1.3;
}

.choice-card-example {
  opacity: 0.55;
  font-style: italic;
  line-height: 1.25;
}
</style>
